class BannerWithTextAnimation extends HTMLElement {
  constructor() {
    super();

    this.isMobile = window.innerWidth <= 990;
    this.handleResize = this.handleResize.bind(this);
    this.swiperInstance = null;
    this.initializedMode = null;
  }

  connectedCallback() {
    this.initialize();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  initialize() {
    const isMobile = window.innerWidth <= 990;

    if (this.initializedMode === (isMobile ? 'mobile' : 'desktop')) return;

    this.initializedMode = isMobile ? 'mobile' : 'desktop';

    if (isMobile) {
      this.initSwiper();
    } else {
      this.initTextHoverImageSwap();
    }
  }

  handleResize() {
    const isMobile = window.innerWidth <= 990;

    if (isMobile && this.initializedMode !== 'mobile') {
      this.destroySwiper();
      this.initialize();
    } else if (!isMobile && this.initializedMode !== 'desktop') {
      this.initialize();
    }
  }

  initSwiper() {
    const slider = this.querySelector('.banner-text-animation-slider');
    if (!slider) return;

    this.swiperInstance = new Swiper(slider, {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    this.initArrows();
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  initTextHoverImageSwap() {
    const texts = this.querySelectorAll('.banner-text-animation__left .text-item');
    const images = this.querySelectorAll('.banner-text-animation__right .image-container');
    this.desktopActiveIndex = 0;

    texts.forEach((text, index) => {
      text.addEventListener('mouseenter', () => {
        this.setDesktopActive(index, texts, images);
      });
    });

    this.initArrows();
  }

  setDesktopActive(index, texts, images) {
    if (!texts) {
      texts = this.querySelectorAll('.banner-text-animation__left .text-item');
    }
    if (!images) {
      images = this.querySelectorAll('.banner-text-animation__right .image-container');
    }

    texts.forEach(t => t.classList.remove('text-item--active'));
    images.forEach(img => img.classList.remove('image-container--active'));

    if (texts[index]) texts[index].classList.add('text-item--active');
    const imgId = texts[index]?.getAttribute('data-image');
    if (imgId) {
      const targetImage = this.querySelector(`#${imgId}`);
      if (targetImage) targetImage.classList.add('image-container--active');
    }

    this.desktopActiveIndex = index;
  }

  initArrows() {
    const prevBtn = this.querySelector('.banner-text-animation__arrow--prev');
    const nextBtn = this.querySelector('.banner-text-animation__arrow--next');

    if (!prevBtn || !nextBtn) return;

    this.prevBtn = prevBtn;
    this.nextBtn = nextBtn;

    // Set initial state — prev disabled on first slide
    this.updateArrowState(0);

    prevBtn.addEventListener('click', () => {
      if (this.swiperInstance) {
        this.swiperInstance.slidePrev();
      } else {
        const texts = this.querySelectorAll('.banner-text-animation__left .text-item');
        const total = texts.length;
        if (total === 0 || this.desktopActiveIndex <= 0) return;
        const newIndex = this.desktopActiveIndex - 1;
        this.setDesktopActive(newIndex);
        this.updateArrowState(newIndex, total);
      }
    });

    nextBtn.addEventListener('click', () => {
      if (this.swiperInstance) {
        this.swiperInstance.slideNext();
      } else {
        const texts = this.querySelectorAll('.banner-text-animation__left .text-item');
        const total = texts.length;
        if (total === 0 || this.desktopActiveIndex >= total - 1) return;
        const newIndex = this.desktopActiveIndex + 1;
        this.setDesktopActive(newIndex);
        this.updateArrowState(newIndex, total);
      }
    });

    // Listen for swiper slide changes
    if (this.swiperInstance) {
      this.swiperInstance.on('slideChange', () => {
        const total = this.swiperInstance.slides.length;
        this.updateArrowState(this.swiperInstance.activeIndex, total);
      });

      // Set initial state for swiper
      this.updateArrowState(0, this.swiperInstance.slides.length);
    }
  }

  updateArrowState(activeIndex, total) {
    if (!this.prevBtn || !this.nextBtn) return;

    if (!total) {
      const slides = this.swiperInstance?.slides || this.querySelectorAll('.banner-text-animation__left .text-item');
      total = slides.length;
    }

    this.prevBtn.disabled = activeIndex <= 0;
    this.nextBtn.disabled = activeIndex >= total - 1;
  }
}

customElements.define('banner-text-animation', BannerWithTextAnimation);
